import { PortalUser } from 'src/app/feature-module/portal-users/models/PortalUser';

import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]]
    }
  ]
})
export class UserFormComponent implements OnInit {
  
  @Input() form: UntypedFormGroup;

  editMode: boolean;
  portalUser: PortalUser;

  ngOnInit(): void {

    this.portalUser = this.form.value;
    this.editMode = (this.portalUser.id.length > 0)

    if(this.editMode){
      this.form.get('userName').disable();
    }
  }

  avatarSet(event:string){
    this.form.controls.avatar.setValue(event);
  }
}
